import { USER_INFO } from "state/actions/user";
import { User } from "types";
import createReducer from "./createReducer";

export default createReducer<User>({ successType: USER_INFO });
